import React from "react";
import "./Footer.scss";

export const Footer: React.FC = () => {
  // current year
  return (
    <p className="footer-ptg">
      © {new Date().getFullYear()} Nserix. All rights reserved.
    </p>
  );
};
